export const ONE_TIME_SURVEY_OPTIONS = [
  {
    displayText: 'Under 5 leads/month',
    value: 5,
  },
  {
    displayText: '5-10 leads/month',
    value: 10,
  },
  {
    displayText: '10-20 leads/month',
    value: 20,
  },
  {
    displayText: 'Over 20 leads/month',
    value: 99,
  },
];
